type DataItem = {
    key: number;
    resourceType: string;
    selectRegion: string;
    serviceLineCapability: string;
    function: string;
    selectLevel: string;
    loadedLaborCostHr: number;
    targetClientMargin: number;
    proposedPriceHr: number;
    targetPriceHr: number;
    clientMarginProposed: number;
    varianceTargetMargin: number;
    resourceRequirementId?: string;
};

type DistinctValues = {
    resourceTypes: string[];
    selectRegions: string[];
    serviceLineCapabilities: string[];
    functions: string[];
    selectLevels: string[];
};

// Define string fields that need validation
type StringFields = 'resourceType' | 'selectRegion' | 'serviceLineCapability' | 'function' | 'selectLevel';

// Define field validation hierarchy
const validationSteps: Array<{
    field: StringFields,
    validValues: keyof DistinctValues
}> = [
    { field: 'resourceType', validValues: 'resourceTypes' },
    { field: 'selectRegion', validValues: 'selectRegions' },
    { field: 'serviceLineCapability', validValues: 'serviceLineCapabilities' },
    { field: 'function', validValues: 'functions' },
    { field: 'selectLevel', validValues: 'selectLevels' }
];

// Default empty numeric values
const defaultNumericValues = {
    loadedLaborCostHr: 0,
    targetClientMargin: 0,
    proposedPriceHr: 0,
    targetPriceHr: 0,
    clientMarginProposed: 0,
    varianceTargetMargin: 0
};

const cleanUiResourceRequestList = (data: DataItem[], distinctValues: DistinctValues): DataItem[] => {
    return data.map(item => {
        const newItem = { ...item };
        
        // Iterate through validation steps in order
        for (let i = 0; i < validationSteps.length; i++) {
            const { field, validValues } = validationSteps[i];
            
            // Check if the current field's value is valid
            if (!distinctValues[validValues].includes(newItem[field])) {
                // Clear this field and all subsequent fields
                for (let j = i; j < validationSteps.length; j++) {
                    const fieldToClear = validationSteps[j].field;
                    newItem[fieldToClear] = "";
                }
                
                // Reset all numeric values
                Object.assign(newItem, defaultNumericValues);
                
                break; // Exit the validation loop once we find a failure
            }
        }
        
        return newItem;
    });
};

export default cleanUiResourceRequestList;
